import { JOIN_NAME, SPLIT_NAMES } from '@/constant'
import type { FormInstance } from 'rc-field-form'
import { useCallback } from 'react'

export const useAddress = (formInstant: FormInstance) => {
  const handleAddressNameChange = useCallback(
    (value: Record<string, any>) => {
      const [key] = Object.entries(value)[0]
      // 如果是拆分的话，需要同步到合并的值
      if (SPLIT_NAMES.includes(key)) {
        const nickname = SPLIT_NAMES.reduce((cur, self) => {
          const v = formInstant.getFieldValue(self)
          cur.push(v)
          return cur
        }, []).filter(Boolean)

        formInstant.setFieldsValue({
          [JOIN_NAME]: nickname.join(''),
        })
      }
      // 如果是改变合并的值，就需要清空原来拆分的
      if (key === JOIN_NAME) {
        const resetV = SPLIT_NAMES.reduce((cur, self) => {
          return {
            ...cur,
            [self]: '',
          }
        }, {})
        formInstant.setFieldsValue(resetV)
      }
    },
    [formInstant]
  )
  return {
    handleAddressNameChange,
  }
}
